import moment from "moment";
import { store } from "../store";

export function gridPageSettings() {
  try {
    const { app } = store.getState();
    const { systemDefaults } = app;
    console.log(systemDefaults);
    return {
      pageSize: systemDefaults?.rowsPerPage || 50,
      pageSizes: ["50", "100", "150", "200", "500", "1000"],
    };
  } catch (err) {
    return {};
  }
}
